import React, { Component } from "react";
import "./member.scss?202104";
import { Toast} from "antd-mobile";
import axios from "../axios";
import tequan from "../assets/tequan.png"
import tequan1 from "../assets/tequan1.png";
import tequan2 from "../assets/tequan2.png";
import unselect from "../assets/Unselected.png"
import select from "../assets/Selected.png"
import zfb from "../assets/zhifubao.png"
import wx from "../assets/weixin.png"
import close from "../assets/closePub.png"


var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

class contract extends React.Component {
	state = {
		dialogFlag: false,	//弹窗标识
		agreeFlag: false,	//协议同意标识
		payType: 'zfb',	//支付类型
		userInfo: {},	//用户信息
	};
  
	componentDidMount () {
		const _this = this;
		axios.post("/user/json/getShopInfor",{userId:_this.props.match.params.userId}).then(function(response) {
			console.log(response)
			_this.setState({
				userInfo: response.data.resultObject
			})
		});
	};
  
	agreement = () => {
		this.setState({
			agreeFlag: true
		})
	};
	
	//申请
	replay = () => {
		if (this.state.userInfo.userType < 2) {
			Toast.fail("认证用户才可以升级旗舰店,请前往个人中心认证", 3);
			return
		};
		if (!this.state.agreeFlag) {
			Toast.fail("请阅读并同意协议后才可以申请", 3);
			return
		};
		this.setState({
			dialogFlag: true
		})
	};
	
	//关闭弹窗
	closeDialog = () => {
		this.setState({
			dialogFlag: false
		})
	};
	
	//支付类型切换
	changePayType = (type) => {
		this.setState({
			payType: type
		})
	};
	
	//支付
	payMent = () => {
		this.setState({
			dialogFlag: false
		});
		let obj = {
			payValid: this.state.userInfo.payValid,
			payType: this.state.payType,
			amount: this.state.userInfo.amount,
		};
		let strObj = JSON.stringify(obj);
		
		if(isiOS){
			try {
			  window.webkit.messageHandlers.IOSNativeFlagShipPayMent.postMessage(obj);
			} catch (e) {
			  console.log(e);
			}
		}else {
			try {
			  window.app.AndroidFlagShipPayMent(strObj);
			} catch (e) {
			  console.log(e);
			  // setTimeout(function () {
			  //   Toast.fail("请升级最新版本,当前版本过低暂不支持此功能", 3);
			  // }, 2000);
			}
		}
	}

  
	render() {	
		return (
			<div className="flagShip">
				<div className="top">
					<div className="back"></div>
					<div className="info">
						<div className="infoList">
							<label>姓名</label> <span>{this.state.userInfo.realName}</span>
						</div>
						{
						// 	this.state.userInfo.isShop == 'Y'?null:<div className="infoList">
						// 	<label>手机号</label> <span>{this.state.userInfo.realName}</span>
						// </div>
						}
						<div className="infoList">
							<label>身份证号</label> <span>{this.state.userInfo.identityNum}</span>
						</div>
						{
							this.state.userInfo.isShop == 'Y'?<div className="infoList">
							<label>旗舰店到期时间</label> <span>{this.state.userInfo.timeStr}</span>
						</div>:null
						}
						<div className="infoList">
							<label>旗舰店管理费</label> <span>{this.state.userInfo.amount}元</span>
						</div>
						<div className="infoList hint">
							<label>有效期为一年</label> <span></span>
						</div>
					</div>
					
				</div>
				<div className="main">
					 <img src={tequan1} />
					 <img src={tequan2} />
					 <div className="protocol"> <img className="icon" src={this.state.agreeFlag?select:unselect} onClick={() => this.agreement()}/>  <span>申请旗舰店必须同意 <a href="http://app.youbao360.com/h5/newHelpcenter/transaction.html">《现货、预买/预售交易规则》</a> <a href="#/rule">《保证金处罚规则》</a></span> </div>
				</div>
				<div className="agreeMent" onClick={() => this.replay()}>{this.state.userInfo.isShop==='Y'?'续费旗舰店':'升级旗舰店'}</div>
				{
					this.state.dialogFlag?<div className="dialog">
					<div className="payDialog">
						<div className="payTop">
							<h4>旗舰店管理费</h4>
							<img src={close} className="closeDialog" onClick={()=> this.closeDialog()}/>
						</div>
						<div className="payMain">
							<div className="prise">
								<span>￥</span>
								{this.state.userInfo.amount}
							</div>
							<div className="payType" onClick={() => this.changePayType('zfb')}>
								<img  src={zfb} className="payIcon"/>
								<span className="name">支付宝</span>
								<img src={this.state.payType==='zfb'?select:unselect} className="choose"/>
							</div>
							<div className="payType" onClick={() => this.changePayType('wx')}>
								<img  src={wx} className="payIcon"/>
								<span className="name">微信</span>
								<img src={this.state.payType==='zfb'?unselect:select} className="choose"/>
							</div>
						</div>
						<div className="payBtn" onClick={() => this.payMent()}>立即支付</div>
					</div>
				</div>:null
				}
				
			</div>
		);
	}
}

export default contract;
